var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 515,
    viewBox: "0 0 515 515",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.66667,0,0,2.66667,458.56,443.557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-69.533L-31.654,-95.497L-164.659,8.986C-171.757,14.562 -167.814,25.964 -158.788,25.964L-34.155,25.964C16.425,25.964 39.108,-37.455 0,-69.533",
    style: {
      fill: "rgb(77,186,211)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.66667,0,0,2.66667,56.4397,71.4432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,69.533L31.654,95.497L164.659,-8.986C171.757,-14.562 167.814,-25.964 158.788,-25.964L34.155,-25.964C-16.425,-25.964 -39.108,37.455 0,69.533",
    style: {
      fill: "rgb(248,148,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.66667,0,0,2.66667,199.494,188.899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,51.451L95.344,24.483L65.496,0L0,51.451Z",
    style: {
      fill: "rgb(148,50,126)",
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColor);
export default __webpack_public_path__ + "static/media/icon_color.4b5a0bf52d4ed9a917e076e007094572.svg";
export { ForwardRef as ReactComponent };